import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {GenericCrudService} from '@gatewee/services/generic-crud.service';
import {Observable} from 'rxjs';
import {RecipientUser} from '@gatewee/types/user';

@Injectable({
  providedIn: 'root',
})
export class UsersService extends GenericCrudService<RecipientUser> {
  constructor(public override http: HttpClient) {
    super('/recipients-users/recipient', http);
  }

  resendInvitation(id: number): Observable<RecipientUser> {
    return this.http
      .get<RecipientUser>(this.baseUrl + '/resend-invitation/' + id)
      .pipe();
  }
}
